class ExploreModule {
    constructor(selector) {
        this.selector = selector;
        this.exploreButtons = document.querySelectorAll(selector);
        this.initExplore();
    }

    initExplore() {
        this.exploreButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const buttonParentSection = button.closest('section');
                const nextSection = buttonParentSection.nextElementSibling;
                if (nextSection) {
                    nextSection.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    }
}

export default ExploreModule;
